import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck --}}\n<div class=\"modal-body\" ...attributes>\n  {{yield}}\n</div>", {
  moduleName: "ember-bootstrap/components/bs-modal/body.hbs"
});